module.exports = __webpack_public_path__ + "1792771649312/fonts/Comfortaa-Medium.1c593a5.ttf";